import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { restaurantConfig } from 'restaurant'
import { showMsg } from '@utils'
import './index.scss'

interface IProps {
  mealsWaitingTime: IMealsWaitingTime;
  onRefresh?: () => void;
}

/** 餐品等待时间，等待单数 */
const WaitingOrderBar: React.FC<IProps> = ({ mealsWaitingTime, onRefresh }) => {
  // const [showWaiting, setShowWaiting] = useState(true)
  const handleReload = () => {
    onRefresh?.()
    showMsg(i18n.t('order.refreshOk'))
  }
  // 显示等待时间
  const isShow = (typeof mealsWaitingTime?.waitingTime === 'number' && typeof mealsWaitingTime?.leastTime === 'number' && mealsWaitingTime?.waitingTime > mealsWaitingTime?.leastTime) && (mealsWaitingTime?.scene && !!mealsWaitingTime?.scene[restaurantConfig.codeType === 'brand' ? 'pickup' : 'dinein'])

  return (
    isShow ? (
      <div className='order-waiting-position-wrapper'>
        <p>
          <span data-cypid='orderReloadOrderNum'>
            {!mealsWaitingTime?.content || mealsWaitingTime?.content?.order === 1 ? i18n.t('menu.mealsWaitingOrderNum', { cnt: mealsWaitingTime?.orderUnMealedNum }) : ''}
          </span>
          <span>
            {!mealsWaitingTime?.content || mealsWaitingTime?.content?.order === 1 && mealsWaitingTime?.content?.time === 1 ? '/' : ''}
          </span>
          <span data-cypid='orderReloadOrderTime'>
            {!mealsWaitingTime?.content || mealsWaitingTime?.content?.time === 1 ? i18n.t('menu.mealsWaitingTime1', { minute: mealsWaitingTime?.waitingTime }) : ''}
          </span>
        </p>
        <i className='iconfont icon-renew' data-cypid='orderReload' onClick={handleReload}></i>
      </div>
    ) : null
  )
}

export default observer(WaitingOrderBar)
